import $ from '../core/Dom';

export default el => {

    const form = $(el);

    const deleteButtons = form.find('[data-delete]');

    const submitButton = form.find('[data-submit]');

    const onDeleteClick = e => {
        // e.preventDefault();
        const field = document.getElementById(e.triggerTarget.dataset.delete);
        field.value = '';
        el.submit();
    };

    const onFormChange = e => {
        submitButton.removeClass('js:hidden');
    };

    const init = () => {
        deleteButtons.on('click', onDeleteClick);
        form.on('change', onFormChange);
    };

    const destroy = () => {
        deleteButtons.off('click', onDeleteClick);
        form.off('change', onFormChange);
    };

    return {
        init,
        destroy
    };
};
